<template>
    <div class="subwrap modulewrap">
        <div class="subbody realwrap" :style="{height:courseheight+'px'}" v-if="$common.basic.isarrayexist(coursedata)">
            <div class="coursenav" :style="{left:navleft+'px'}">
                <div class="coursenavwrap">
                    <div class="coursetitle btn" @click="showdetail(-1)">
                        <ffoverdot :title="leveldata.title" :title_en="leveldata.title_en" myclass="a"></ffoverdot>
                        <ffoverdot :title="coursetree.title" :title_en="coursetree.title_en" myclass="b"></ffoverdot>
                    </div>
                    <div class="topicwrap">
                        <div class="linetop"></div>
                        <myScroll class="scroll">
                            <div class="topiclist">
                                <div class="line"></div>
                                <div class="topic" v-for="(item,index) in coursetree.x_children" :key="item.id">
                                    <div class="title btn">
                                        <dl :title="$common.langinfo( item.title,item.title_en)" @click="showdetail(item.id)">
                                            <dt>{{$common.dicword('topic')}}</dt>
                                            <dd class="a"><span class="circle">{{(index+1)}}</span></dd>
                                            <dd class="b"><ffoverdot :title="item.title" :title_en="item.title_en" :needtitle="false"></ffoverdot></dd>
                                            <dd class="c"><i class="iconfont icon-zhankai" :style="{transform: 'rotate('+(item.x_isopen?'180':'0')+'deg)'}"></i></dd>

                                        </dl>
                                    </div>
                                    <transition name="slidedown">
                                        <div class="lesson" v-show="item.x_isopen">
                                            <dl :class="['btn',{cs:(item2.id==curid)||(item2.id==coursecur.pid)}]" :title="$common.langinfo( item2.title,item2.title_en)" v-for="(item2,index2) in item.x_children" :key="item2.id" @click="showdetail(item2.id)">
                                                <dd class="a">
                                                    <span class="circle">
                                                        <span v-if="item2.x_perc==0" class="ready"></span>
                                                        <span v-else-if="item2.x_perc==100" class="done"></span>
                                                        <template v-else>
                                                            <span class="doing" :style="{transform: 'rotate('+(item2.x_perc*3.6)+'deg)'}"></span>
                                                            <span :class="[item2.x_perc<=50?'fanless':'fanmore']"></span>
                                                        </template>
                                                    </span>
                                                </dd>
                                                <dd class="b">{{(index2+1)}}.<ffoverdot :title="item2.title" :title_en="item2.title_en"></ffoverdot></dd>
                                            </dl>

                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </myScroll>
                    </div>
                    <div v-if="istesting" class="coursenavmask"></div>
                </div>

                <div class="switch" @click="showcoursenav()"><i class="iconfont icon-fanye1" :style="{transform:'rotate('+navrotate+'deg)'}"></i></div>

            </div>
            <div class="coursemain" @click="showcoursenav(false)">
                <div class="top">

                    <div v-if="istesting" class="titletest">
                        <div class="titleleft" v-html="$common.langinfo(coursecur.title,coursecur.title_en)"></div>
                        <div class="titleright">
                            <template v-if="!$store.getters.issmall">
                                <i class="iconfont icon-naozhong"></i>
                                {{$common.dicword('remaintime',true)}}
                            </template>
                            {{$common.basic.chint2timewithsecond(examinfo.remainseconds)}}<a href="#" @click="testsubmit()" :class="[{'disable':qcount!=qmax}]">{{$common.dicword('submit')}}</a>
                        </div>
                    </div>
                    <template v-else>
                        <div v-if="iste && coursecur.lev==2" class="title artititle">
                            <span v-html="coursecur.lev==3?$common.langinfo(courseparent.title,courseparent.title_en):$common.langinfo(coursecur.title,coursecur.title_en)"></span>
                            <a href="#" @click="istefull=true">{{$common.dicword('fullscreenstudy')}}</a>
                        </div>
                        <div v-else class="title">
                            <span v-html="coursecur.lev==3?$common.langinfo(courseparent.title,courseparent.title_en):$common.langinfo(coursecur.title,coursecur.title_en)"></span>
                        </div>


                    </template>

                    <div class="link" v-if="!iste &&(coursecur.isquiz!=1)">
                        <a v-for="item in coursecur.x_infolist" :key="item.id" href="#" :class="item.x_kind" @click="showinfo(item.id)" v-html="$common.langinfo(item.title,item.title_en)"></a>
                        <template v-if="coursecur.lev==3">
                            <a v-for="item in courseparent.x_infolist" v-if="$common.courseinfotype.Writing(item.courseinfotypekv)" :key="item.id" href="#" :class="item.x_kind" @click="showinfo(item.id)" v-html="$common.langinfo(item.title,item.title_en)"></a>
                        </template>

                    </div>

                </div>
                <div class="conwrap">
                    <div v-if=" coursecur.isquiz==1 && examinfo.stat>0 && examinfo.lessonid==coursecur.id && !iste" class="con">
                        <div class="learntestinfo">
                            <myScroll class="scroll">
                                <div class="qpart">
                                    Part {{examinfo.partindex + 1}}  -  {{partcur.title}}  <span>({{$common.dicword('questioncount',true)}}{{partcur.usc}}，{{$common.dicword('questionscore',true)}}{{partcur.score}})</span>
                                </div>
                                <dl class="qstem">
                                    <dt>{{(examinfo.qindex+1)}}.</dt>
                                    <dd class="editor"><span v-html="$common.basic.ffinputline(questioncur.constem)"></span></dd>
                                </dl>

                                <label v-for="(item,index) in questioncur.x_conoptions" :key="item.id">
                                    <dl class="choice">
                                        <dt>
                                            <template v-if="examinfo.stat<=2">
                                                <input type="radio" @change="questionchoose" name="Ra" v-model="answercur.selectoption" :value="item.id" />
                                            </template>
                                            <template v-else>
                                                <span :class="answerstat(examinfo.partindex,examinfo.qindex,(index+1))"></span>
                                            </template>
                                            {{$common.basic.chint2letter(index)}}.
                                        </dt>
                                        <dd v-html="item.conoption"></dd>
                                    </dl>
                                </label>
                                <dl class="qstem" v-if="!$store.getters.isstu && answeranalysis(examinfo.partindex,examinfo.qindex)">
                                    <dt>&nbsp;</dt>
                                    <dd class="editor"><span v-html="answeranalysis(examinfo.partindex,examinfo.qindex)"></span></dd>
                                </dl>
                            </myScroll>
                        </div>
                        <div class="learntestsidewrap">
                            <myScroll class="scroll">
                                <div class="learntestside">
                                    <div v-if="examinfo.stat<=2" class="progressbar">
                                        <div class="title"><span class="a">{{$common.dicword('answerprogress')}}</span><span class="b">{{qcount}}/{{qmax}}</span></div>
                                        <div class="bar">
                                            <div class="cur"><span class="line" :style="{width:qprogress+'%'}"></span><span class="circle"></span></div>
                                        </div>
                                        <div class="tip">{{$common.dicword('totalscore',true)}}{{testdata.gradetotal}}</div>
                                    </div>
                                    <div v-else class="progressbar">
                                        <div class="title" v-if="$store.getters.isstu"><span class="a">{{$common.dicword('score',true)}}</span><span class="b">{{testdata.grade}}</span></div>
                                        <div class="title" v-else><span class="a">{{$common.dicword('totalscore',true)}}</span><span class="b">{{testdata.gradetotal}}</span></div>
                                    </div>
                                    <dl class="answertype">
                                        <dd v-if="examinfo.stat>2"><span class="right"></span>{{$common.dicword('statright')}}</dd>
                                        <dd v-if="examinfo.stat>2"><span class="error"></span>{{$common.dicword('staterror')}}</dd>
                                        <dd v-if="examinfo.stat<=2"><span class="done"></span>{{$common.dicword('statdone')}}</dd>
                                        <dd v-if="examinfo.stat<=2"><span class="ready"></span>{{$common.dicword('statready')}}</dd>
                                    </dl>
                                    <div class="answersheet">
                                        <myScroll class="scroll">
                                            <div class="aspart" v-for="(item,index) in testdata.paper" :key="index">
                                                <div class="qtype"><span>{{(index+1)}}</span> {{item.title}}</div>
                                                <dl>
                                                    <dd v-for="(item2,index2) in item.questionlist" :key="index2" :class="choicestat(index,index2)" @click="questiongo(index,index2)"></dd>
                                                </dl>
                                            </div>
                                        </myScroll>
                                    </div>
                                </div>
                            </myScroll>
                        </div>
                    </div>

                    <div v-else class="con">
                        <div :class="['info',{infohasmedia:coursecur.x_hasmedia}]">
                            <template v-if="iste">
                                <Carti v-if="isshowarti" :info="coursecur" :isfull.sync="istefull" @articomplete="articomplete"></Carti>
                                <div v-if="coursecur.lev!=2" class="content concenter" v-html="coursecur.content"></div>
                            </template>
                            <template v-else>
                                <myScroll class="scroll">
                                    <div class="content editor" ref="mycontent" v-html="tranvocab($common.langinfo( coursecur.content,coursecur.content_en))"></div>
                                </myScroll>

                            </template>
                        </div>
                        <div v-if="coursecur.x_hasmedia" class="sidewrap">
                            <myScroll class="scroll">
                                <div class="side">
                                    <dl v-if="!$common.basic.chempty(coursecur.imgs)" v-viewer>
                                        <dd v-for="item in coursecur.imgs.split(',')" :key="item"><img :src="item" /></dd>
                                    </dl>
                                    <dl v-if="!$common.basic.chempty(coursecur.video)">
                                        <dd class="video"><a href="#" @click="showvideo(coursecur.video)"><img :src="coursecur.videoimg" /><span><i class="iconfont icon-bofang"></i></span></a></dd>
                                    </dl>
                                </div>
                            </myScroll>
                        </div>
                    </div>

                    <div v-if="coursecur.lev>=2 && !iste && (coursecur.isquiz!=1)" class="page">
                        <a href="#" v-for="(item,index) in pagesetting" :key="index" :class="{cs:(item.id==curid&&item.id>=0)}" @click="showdetail(item.id)">{{(item.title)}}</a>
                    </div>
                    <div v-if="coursecur.isquiz==1 && !iste" class="learntestbtn">
                        <a v-if="(!$store.getters.isstu||(coursecur.x_quizstat==9)) && examinfo.stat==0" href="#" @click="testbegin">{{$common.dicword('examview')}}</a>
                        <a href="#" v-else-if="examinfo.stat==0 && !islearning">{{$common.dicword('waitschedule')}}</a>
                        <a v-else-if="examinfo.stat==0" href="#" @click="testbegin">{{$common.dicword('examstart')}}</a>

                        <template v-else>
                            <a href="#" :class="{'disable':isbegin}" @click="questionprev">{{$common.dicword('examprev')}}</a>
                            <a href="#" :class="{'disable':isend}" @click="questionnext">{{$common.dicword('examnext')}}</a>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog v-if="isshowvideo &&(videocur!='')" :visible.sync="isshowvideo" top="0px" class="mydialog">
            <video :src="videocur" controls autoplay controlslist="nodownload" @contextmenu.prevent=""></video>
        </el-dialog>
        <el-dialog v-if="isshowinfo" :visible.sync="isshowinfo" top="0px" class="mydialog2">
            <div class="mydialogwrap">
                <Ccourseinfo :courseinfo="infocur" @ffsubmit="submitinfo" :islearning="islearning"></Ccourseinfo>
            </div>
        </el-dialog>
        <el-dialog v-if="isshowvocab" :visible.sync="isshowvocab" top="0px" class="mydialogvocab">
            <div class="mydialogwrap">
                <div class="title"><span class="arrow"></span><span class="word"><i class="iconfont icon-wenhao"></i>{{$common.dicword('vocab')}}</span></div>
                <div class="con">
                    <div class="info">
                        <myScroll class="scroll">
                            <div class="content editor" v-html="vocabinfo.content"></div>
                        </myScroll>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import Cookie from 'vue-cookies';

    export default {
        name: 'course',
        components: {
            Ccourseinfo: () => import('@/components/Ccourseinfo'),
            Carti: () => import('@/components/Carti')
        },
        data() {
            return {
                sourcecourse: {},//来源课程，仅实用于test
                iste: false,//TENG
                learnid: 0,//在学记录
                coursedata: [],
                leveldata: {},
                vocab: '',
                isshowvocab: false,
                vocabinfo: {},
                curid: 0,
                curinfoid: 0,
                prepageid: 0,
                courseheight: 500,
                isshowvideo: false,
                videocur: '',
                isshowinfo: false,
                isshowarti: false,
                sleepsecond: 0,
                myinterval: '',
                isshowcoursenav: false,//小窗口用
                examinfodefault: {
                    id: 0,
                    lessonid: 0,
                    courseid: 0,
                    stat: 0,
                    remainseconds: 0,
                    qindex: 0,
                    partindex: 0,
                    answersheet: []
                },
                examinfo: {},
                testdata: {},
                remaininterval: '',
                istefull: false,//arti全屏显示
                savetimeout: '',
                isneedsave: false,//是否需要保存
                islearning: false// 是否在课程表中
                //isteacher: false
            }
        },
        computed: {
            courselist: function () {
                return this.setcoursedata(this.coursedata);
            },
            coursecur: function () {
                return this.$common.basic.fffind(this.coursedata, 'id', this.curid);
            },
            courseparent: function () {
                return this.$common.basic.fffind(this.coursedata, 'id', this.coursecur.pid);
            },
            coursetree: function () {
                return this.courselist[0];
            },
            cookiename: function () {
                return 'examinfo_' + this.coursetree.id;
            },
            infocur: function () {
                return this.$common.basic.fffind(this.coursedata, 'id', this.curinfoid);
            },
            pagelist: function () {
                return this.coursecur.lev == 2 ? this.coursecur.x_children : this.coursecur.lev == 3 ? this.courseparent.x_children : [];
            },
            pagemax: function () {
                return this.pagelist.length;
            },
            pagesetting: function () {
                let pageid = this.coursecur.lev < 3 ? 0 : this.coursecur.id;
                let pageindex = pageid == 0 ? -1 : this.pagelist.findIndex(item => item.id == pageid);

                let _pagesetting = []
                _pagesetting.push({ 'id': pageindex > 0 ? this.pagelist[pageindex - 1].id : 0, 'title': '<' });
                let pps = 5;
                let isbegin = true;
                let isend = true;

                let ppbegin = pageindex - 2;
                if (ppbegin <= 0) {
                    ppbegin = 0;
                }
                else {
                    isbegin = false;
                }

                let pplast = ppbegin + pps;
                if (pplast >= this.pagemax) {
                    pplast = this.pagemax;
                }
                else {
                    isend = false;
                }

                if (isend && !isbegin) {
                    ppbegin = pplast - pps;
                    if (ppbegin <= 0) {
                        ppbegin = 0;
                        isbegin = true;
                    }
                }

                if (!isbegin) {
                    _pagesetting.push({ 'id': this.pagelist[ppbegin - 1].id, 'title': '...' });
                }
                for (var i = ppbegin; i < pplast; i++) {
                    _pagesetting.push({ 'id': this.pagelist[i].id, 'title': (i + 1) });
                }
                if (!isend) {
                    _pagesetting.push({ 'id': this.pagelist[pplast].id, 'title': '...' });
                }
                _pagesetting.push({ 'id': pageindex < this.pagemax - 1 ? this.pagelist[pageindex + 1].id : 0, 'title': '>' });
                return _pagesetting;
            },


            navleft: function () {
                return this.isshowcoursenav ? 0 : - 265;
            },
            navrotate: function () {
                return this.isshowcoursenav ? 180 : 0;
            },
            qcount: function () {
                let answerd = this.examinfo.answersheet.filter(item => item.selectoption) || [];
                return answerd.length;
            },
            qmax: function () {
                return this.examinfo.answersheet.length;
            },
            qprogress: function () {
                return this.qmax == 0 ? 0 : Math.round(this.qcount * 100 / this.qmax)
            },
            partcur: function () {
                return this.testdata.paper ? this.testdata.paper[this.examinfo.partindex] || {} : {};
            },
            questioncur: function () {
                return this.partcur.questionlist ? this.partcur.questionlist[this.examinfo.qindex] || {} : {};
            },
            answercur: function () {
                return this.$common.basic.fffind(this.examinfo.answersheet, 'id', this.questioncur.id);
            },
            modifyfirst: function () {
                return [0, 0];
            },
            modifylast: function () {
                return this.testdata.paper ? [this.testdata.paper.length - 1, this.testdata.paper[this.testdata.paper.length - 1].questionlist.length - 1] : [0, 0];
            },
            isbegin: function () {
                return (this.examinfo.partindex == this.modifyfirst[0]) && (this.examinfo.qindex == this.modifyfirst[1]);
            },
            isend: function () {
                return (this.examinfo.partindex == this.modifylast[0]) && (this.examinfo.qindex == this.modifylast[1]);
            },

            istesting: function () {
                return this.$store.getters.isstu && this.examinfo.stat > 0 && this.examinfo.stat < 9 && (this.$common.basic.isarrayexist(this.coursedata) ? this.coursetree.id == this.examinfo.courseid : false);
            }
        },
        methods: {
            setwrap: function () {
                let ch = window.innerHeight - 250;

                this.courseheight = ch > 600 ? ch : 600;
            },
            setcoursedata: function (listdata, lev = 0, pid = 0) {
                let treedata = [];
                if (this.$common.basic.isarrayexist(listdata)) {

                    treedata = listdata.filter(item => (item.lev == lev) && (item.pid == pid) && (lev == 0 || this.$common.courseinfotype.Content(item.courseinfotypekv))) || [];
                    this.$common.each(treedata, item => {

                        item.x_children = this.setcoursedata(listdata, lev + 1, item.id);

                        item.x_infolist = listdata.filter(item2 => (item2.lev == lev + 1) && (item2.pid == item.id) && this.$common.courseinfotype.Info(item2.courseinfotypekv));
                        item.x_hasmedia = (item.imgs || item.video);
                    });
                }
                return treedata;
            },
            examinfoinit: function () {
                let _examinfo = Cookie.get(this.cookiename);
                if (this.$common.basic.chempty(_examinfo)) {
                    this.examinfo = this.$common.basic.jsonclone(this.examinfodefault);
                }
                else {
                    this.examinfo = _examinfo;
                }

            },
            datainit: function () {
                let subfn = this.$route.params.sub;
                let subid = this.$route.params.subid || 0;
                let id = this.$common.basic.chstr2int(this.$route.params.id);

                let jsondata = { 'postdata': { 'act': 'tc_learn_course', 'id': id, 'data': { 't': subfn, 'subid': subid } } };

                this.$common.post(jsondata, res => {
                    if (!res.infodata || res.infodata.id == 0) {
                        this.$common.alert('coursexpired');
                        this.$router.replace('/member');
                        return false;
                    }

                    if (res.infodata.typekv == this.$common.CTVIDEO) {
                        let learnurl = '/learn/';
                        if (subfn) {
                            learnurl += subfn + '/' + subid;
                        }
                        else {
                            learnurl += id + (subid ? '/' + subid : '');
                        }
                        this.$router.replace(learnurl);
                        return false;
                    }

                    //this.iste = res.infodatalevel.leveltypekv == this.$common.telev

                    this.iste = res.infodatalevel.typekv == this.$common.CTATRI

                    let _vocab = ''
                    this.$common.each(res.infodatavocab, (item) => {
                        _vocab += '|' + item.title;
                    });
                    if (_vocab != "") {
                        _vocab = _vocab.substring(1);
                        var regext = '( |,|\\.|\\?))|(( )';
                        _vocab = '(( )' + _vocab.replaceAll('\\|', regext) + '( |,|\\.|\\?))';
                    }
                    this.vocab = _vocab;


                    this.$common.each(res.infodatatree, (item) => {
                        item.x_hasmedia = false;
                        item.x_perc = 0;
                        item.x_isload = false;
                        item.x_isopen = false;
                        item.x_children = [];
                        item.x_infolist = [];
                        item.x_quizstat = 0;

                        if (item.lev == 2) {
                            if (item.isquiz == 1) {
                                let examrecord = this.$common.basic.fffind(res.infodataexam, "topicid", item.pid);
                                if (this.$common.basic.isobjexist(examrecord)) {
                                    item.x_perc = 100;
                                    item.x_quizstat = 9;
                                }

                            }
                            else {
                                let pro = this.$common.basic.fffind(res.infodataprogress, 'lessonid', item.id);
                                if (this.$common.basic.isobjexist(pro)) {
                                    item.x_perc = this.iste ? pro.iscomplete == 1 ? 100 : 25 : Math.round(pro.perc);
                                }
                            }
                        }

                        if (this.$common.courseinfotype.Info(item.courseinfotypekv)) {
                            if (this.$common.courseinfotype.Writing(item.courseinfotypekv)) {
                                let fitem = this.$common.basic.fffind(res.infodatawriting, 'writingid', item.id);
                                item.x_kind = (this.$common.basic.isobjexist(fitem)) ? 'done' : 'ready';
                            }
                            else {
                                item.x_kind = 'info';
                            }
                        }

                    });

                    let _courseinfo = this.$common.basic.fffind(res.infodatatree, 'id', res.infodatacourse.id);//替换的coursetree里的course的相关信息

                    _courseinfo.title = res.infodata.title;
                    _courseinfo.title_en = res.infodata.title_en;
                    _courseinfo.content = res.infodatacourse.content;
                    _courseinfo.content_en = res.infodatacourse.content_en;
                    _courseinfo.imgs = res.infodatacourse.imgs;
                    _courseinfo.videoimg = res.infodatacourse.videoimg;
                    _courseinfo.video = res.infodatacourse.video;
                    _courseinfo.x_isload = true;

                    this.sourcecourse = res.infodata;
                    this.curid = _courseinfo.id;
                    this.coursedata = res.infodatatree;
                    this.leveldata = res.infodatalevel;
                    this.islearning = res.islearning == 1;
                    //this.isteacher = res.isteacher == 1;

                    subid = res.subid;

                    this.showdetail(subid);

                });
            },
            getdetail(id, callback) {

                let detail = this.$common.basic.fffind(this.coursedata, 'id', id);
                if (!detail.x_isload) {

                    let jsondata = { 'postdata': { 'act': 'tc_learn_detail', 'id': id }, 'msg': '' };

                    this.$common.post(jsondata, res => {
                        detail.x_isload = true;
                        this.$set(detail, 'content', res.infodatadetail.content);
                        this.$set(detail, 'content_en', res.infodatadetail.content_en);
                        this.$set(detail, 'imgs', res.infodatadetail.imgs);
                        this.$set(detail, 'videoimg', res.infodatadetail.videoimg);
                        this.$set(detail, 'video', res.infodatadetail.video);
                        this.$set(detail, 'conreference', res.infodatadetail.conreference);
                        if (callback != undefined) {
                            callback();
                        }
                    });
                }
                else {
                    if (callback != undefined) {
                        callback();
                    }
                }
            },
            showdetail(id) {
                this.examinfoinit();
                if (this.istesting) {
                    id = this.examinfo.lessonid;
                }
                this.isshowarti = false;
                if (id == 0) {
                    return;
                }
                if (id < 0) {
                    this.curid = this.coursetree.id;
                    this.$common.each(this.coursetree.x_children, item => {
                        item.x_isopen = false;
                    });
                    this.pagesave();
                    return;
                }
                if (this.curid == id) {
                    this.coursecur.x_isopen = !this.coursecur.x_isopen;
                }
                else {
                    this.curid = id;

                    if (this.coursecur.lev == 1) {
                        this.$common.each(this.coursetree.x_children, item => {
                            item.x_isopen = false;
                        });
                        this.coursecur.x_isopen = true;
                    }
                    else {

                        if (this.coursecur.lev == 2) {
                            this.courseparent.x_isopen = true;
                        }
                        else {

                            let ppobj = this.$common.basic.fffind(this.coursedata, 'id', this.courseparent.pid);

                            ppobj.x_isopen = true;
                        }

                    }

                    this.getdetail(id, () => {
                        if (this.istesting) {

                            this.testbegin();
                        }
                        this.pagesavewait();
                    });

                }
                this.$nextTick(() => {
                    this.isshowarti = (this.iste && this.coursecur.lev == 2);
                });

            },
            showvideo: function (v) {
                this.isshowvideo = true;
                this.videocur = v;
            },
            showinfo: function (id) {
                this.getdetail(id, () => {
                    this.curinfoid = id;
                    this.isshowinfo = true;
                });
            },
            submitinfo: function (v) {
                this.infocur.x_kind = v >= 2 ? 'done' : 'ready';
            },
            pagesavewait: function () {
                this.isneedsave = false;
                this.pagesave();
            },
            pagesave: function () {
                if (!this.isneedsave) {
                    window.clearTimeout(this.savetimeout);
                    this.savetimeout = window.setTimeout(() => {
                        this.isneedsave = true;
                        this.pagesavefun();
                    }, 3000);
                }
                else {
                    this.pagesavefun();
                }
            },
            pagesavefun: function () {
                this.showcoursenav(false);//小窗口关闭侧栏
                if (!this.iste) {
                    //let id = this.coursecur.lev == 3 ? this.coursecur.id : 0;
                    if (this.curid) {
                        let id = this.coursecur.id;//id应该就是curid吧
                        if ((id > 0) || (this.learnid > 0)) {
                            let jsondata = {
                                'postdata': { 'act': 'tc_learn_pagesave', 'id': id, 'data': { 'learnid': this.learnid } }, 'msg': ''
                            };
                            this.$common.post(jsondata, (res) => {
                                if (res.infodata) {
                                    this.$common.basic.fffind(this.coursedata, 'id', res.infodata.lessonid).x_perc = res.infodata.perc;
                                }

                                this.learnid = res.learnid;

                            });
                        }
                    }

                }
                this.saveexaminfo();//保存考试信息，只有istesting才会保存
            },
            articomplete: function (v) {
                let perc = v == 1 ? 100 : 25;
                if (perc > this.coursecur.x_perc) {
                    this.coursecur.x_perc = perc;
                }
            },
            showcoursenav: function (isshow) {
                this.isshowcoursenav = isshow == undefined ? !this.isshowcoursenav : isshow;
            },
            testfinish: function () {
                this.coursecur.x_quizstat = 9;//单个考试的状态，只需要知道有没有完成
                this.coursecur.x_perc = 100;

                this.examinfo.stat = 9;//当前考试的状态
                this.examinfo.partindex = 0;
                this.examinfo.qindex = 0;
                this.examinfo.remainseconds = 0;
                Cookie.remove(this.cookiename);
            },
            testbegin: function () {

                let jsondata = {
                    'postdata': {
                        'act': 'tc_learn_test', 'id': this.coursecur.id, 'data': { 'courseid': this.sourcecourse.id }
                    }
                };
                this.$common.post(jsondata, (res) => {
                    if (!res.infodata) {
                        this.testfinish();
                        this.$common.alert('examnopaper');
                        return;
                    }
                    let paper = JSON.parse(res.infodata.conpaperuse);
                    res.infodata.paper = paper.questionsetting;

                    let _answersheet = [];
                    this.$common.each(res.infodata.paper, item => {
                        this.$common.each(item.questionlist, (item2) => {
                            item2.x_conoptions = item2.conoptions ? JSON.parse(item2.conoptions) : [];
                            _answersheet.push({ 'id': item2.id, 'selectoption': '' });
                        });
                    });

                    res.infodata.conreply = res.infodata.conreply ? JSON.parse(res.infodata.conreply) : {};

                    this.testdata = res.infodata;

                    if (this.examinfo.stat == 0) {

                        this.examinfo.id = this.testdata.id;
                        let topicid = this.testdata.topicid;
                        let clesson = this.coursedata.find(item => item.pid == topicid && item.isquiz == 1);
                        this.examinfo.lessonid = clesson.id || 0;
                        this.examinfo.courseid = this.testdata.courseid;
                        this.examinfo.answersheet = _answersheet;
                        this.examinfo.remainseconds = this.testdata.examminutes * 60;

                    }
                    this.examinfo.stat = this.testdata.stat;
                    this.saveexaminfo();


                    if (this.testdata.stat == 9) {
                        this.testfinish();
                    }
                    else {
                        if (this.$store.getters.isstu) {
                            this.examinfo.remainseconds = this.testdata.remainseconds;
                            if (this.testdata.remainseconds == 0) {
                                this.testpost();
                            }
                        }

                    }
                });
            },
            testpost: function () {
                if (this.$store.getters.isstu) {

                    let jsondata = {
                        'postdata': { 'act': 'tc_learn_testsubmit', 'id': this.examinfo.id, 'pid': this.sourcecourse.id, 'data': { 'answersheet': JSON.stringify(this.examinfo.answersheet) } }
                    };
                    this.$common.post(jsondata, (res) => {
                        this.testdata.grade = res.infodata.grade;
                        this.testdata.conreply = res.infodata.conreply ? JSON.parse(res.infodata.conreply) : {};
                        this.testfinish();

                    });
                }
            },
            testsubmit: function () {
                if (this.qcount == this.qmax) {
                    this.$common.confirm("examconfirmsubmit", () => {
                        this.testpost();
                    });
                }
            },
            questiongo: function (p, q) {
                if (this.examinfo.stat > 0) {
                    this.examinfo.partindex = p;
                    this.examinfo.qindex = q;
                }

            },
            questionchoose: function () {
                this.saveexaminfo();
                window.setTimeout(() => {
                    this.questionnext();
                }, 500);
            },
            questionnext: function () {
                let p = this.examinfo.partindex;
                let q = this.examinfo.qindex + 1;
                if (q >= this.testdata.paper[p].questionlist.length) {
                    if (p < this.testdata.paper.length - 1) {
                        p++;
                        q = 0;
                    }

                }

                if ((p >= this.modifylast[0]) && (q >= this.modifylast[1])) {
                    p = this.modifylast[0];
                    q = this.modifylast[1];
                }

                this.examinfo.partindex = p;
                this.examinfo.qindex = q;



            },
            questionprev: function () {

                let q = this.examinfo.qindex - 1;
                let p = this.examinfo.partindex;
                if (q < 0) {
                    if (p > 0) {
                        p--;
                        q = this.testdata.paper[p].questionlist.length - 1;
                    }

                }

                if ((p <= this.modifyfirst[0]) && (q <= this.modifyfirst[1])) {
                    p = this.modifyfirst[0];
                    q = this.modifyfirst[1];
                }

                this.examinfo.partindex = p;
                this.examinfo.qindex = q;

            },


            choicestat: function (p, q) {
                let _choicestat = 'ready';
                let questionid = this.testdata.paper[p].questionlist[q].id;

                if (this.examinfo.stat <= 2) {
                    let answerchoose = this.$common.basic.fffind(this.examinfo.answersheet, 'id', questionid);
                    _choicestat = answerchoose.selectoption ? 'done' : 'ready';
                }
                if (this.examinfo.stat > 2) {
                    let answerchoose = this.$common.basic.fffind(this.testdata.conreply, 'id', questionid);
                    _choicestat = answerchoose.score > 0 ? 'right' : 'error';
                }

                if (((p == this.examinfo.partindex) && (q == this.examinfo.qindex))) {
                    _choicestat += ' cs';
                }
                return _choicestat;
            },
            getanswer: function (p, q) {
                let questionid = this.testdata.paper[p].questionlist[q].id;
                return this.$common.basic.fffind(this.testdata.conreply, 'id', questionid);
            },
            answerstat: function (p, q, v) {
                let answerchoose = this.getanswer(p, q);
                let selected = this.$store.getters.isstu ? answerchoose.selectoption : answerchoose.rightoption;
                return selected == v ? answerchoose.score > 0 ? 'right' : 'error' : 'notchoose';
            },
            answeranalysis: function (p, q) {
                return this.getanswer(p, q).conanalysis;
            },
            saveexaminfo: function () {
                if (this.istesting) {//DEMO应该不保存，测试时试用
                    if (this.examinfo.stat == 9) {
                        this.testfinish();
                    }
                    else {
                        Cookie.set(this.cookiename, this.examinfo, -1);
                    }

                }
            },
            tranvocab: function (str) {

                if ((this.$common.basic.chempty(str)) || (this.vocab == '')) {
                    return str;
                }
                let reg = new RegExp("(?!<[^>]*)(" + this.vocab + ")(?![^<]*>)", "ig");

                let uw = str.replace(reg, function (word) {
                    let lastchar = word.substring(word.length - 1);
                    if ((lastchar == ",") || (lastchar == ".") || (lastchar == "?")) {
                        word = word.substring(0, word.length - 1);
                    }
                    else {
                        lastchar = "";
                    }

                    return '<a href="' + word + '" class="linkvocab"  ref="linkvocab">' + word + '</a > ' + lastchar;
                });


                return uw;
            },
            mymouseover: function () {
                this.sleepsecond = 0;
            },
            mykeyup: function (e) {
                const keyName = e.key;
                if (keyName === 'Escape') {
                    this.istefull = false;
                }
            }
        },
        mounted() {
            this.setwrap();
            window.onresize = () => {
                return (() => {
                    this.setwrap();
                })()
            }
            this.datainit();

            this.myinterval = window.setInterval(() => {
                if (!this.istesting) {
                    this.sleepsecond++;
                    if (this.sleepsecond > 600) {
                        this.$router.replace('/member');
                    }
                }
            }, 1000);

            document.addEventListener('mouseover', this.mymouseover);

            this.remaininterval = window.setInterval(() => {
                if (this.istesting) {
                    this.examinfo.remainseconds = this.examinfo.remainseconds - 1;
                    if (this.examinfo.remainseconds > 0) {
                        //this.saveexaminfo();
                    }

                    if (this.examinfo.remainseconds <= 0) {
                        this.testpost();
                    }
                }
            }, 1000);

            window.addEventListener('beforeunload', this.pagesave);

            document.addEventListener('click', (e) => {
                if (e.target.tagName === 'A') {
                    if (e.target.className == 'linkvocab') {
                        let href = e.target.href;
                        href = this.$common.basic.chempty(href) ? "" : href.substring(href.lastIndexOf("/") + 1);

                        this.isshowvocab = true;

                        this.$common.fetch({ 'act': 'tc_vocab', 'exts': 'alias=' + href }, res => {
                            this.vocabinfo = res.infodata;
                        });

                        if (e.preventDefault) {
                            e.preventDefault();
                        } else {
                            e.returnValue = false;
                        }
                    }
                }
            });

            document.addEventListener('keyup', this.mykeyup);

        },
        beforeDestroy() {
            this.pagesave();
            window.removeEventListener('beforeunload', this.pagesave);
            document.removeEventListener('mouseover', this.mymouseover);
            document.removeEventListener('keyup', this.mykeyup);
            window.clearInterval(this.myinterval);
            window.clearInterval(this.remaininterval);
            window.clearTimeout(this.savetimeout);
        }
    }
</script>
